import { SET_DATA_FIELD } from './actions';

const initialState = {
    objects: [],
    components: [],
    objectsClicked: false,
    componentsClicked: false,
    isLoaded: false,
    dialogOpen: false,
};

export function dataReducer(state = initialState, action) {
    switch (action.type) {
        case SET_DATA_FIELD:
            return { ...state, [action.key]: action.value };
        default:
            return state;
    }
}
